const defaultColumnConfigMap = {
  preview: {
    id: "preview",
    width: 55,
    order: -2,
    resizable: false
  },
  name: {
    id: "name",
    width: 360,
    order: -1,
    resizable: true
  },
  tags: {
    id: "tags",
    width: 200,
    order: 1,
    resizable: true
  },
  comments: {
    id: "comments",
    width: 250,
    order: 2,
    resizable: true
  },
  createdBy: {
    id: "createdBy",
    width: 220,
    order: 3,
    resizable: true
  },
  createdAt: {
    id: "createdAt",
    width: 190,
    order: 20,
    resizable: true
  },
  modifiedAt: {
    id: "modifiedAt",
    width: 190,
    order: 21,
    resizable: true
  },
  kind: {
    id: "kind",
    width: 150,
    order: 30,
    resizable: true
  },
  size: {
    id: "size",
    width: 100,
    order: 40,
    resizable: true
  },
  url: {
    id: "url",
    width: 230,
    order: 50,
    resizable: true
  }
};

export { defaultColumnConfigMap };
//# sourceMappingURL=defaultColumnConfigMap.js.map
